import { render } from "./code.vue?vue&type=template&id=3efa2d28&scoped=true&ts=true"
import script from "./code.vue?vue&type=script&lang=ts"
export * from "./code.vue?vue&type=script&lang=ts"

import "./code.vue?vue&type=style&index=0&id=3efa2d28&lang=less&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa2d28"]])

export default __exports__